import { SpeakerWaveIcon, SpeakerXMarkIcon } from '@heroicons/react/24/solid';
import { useAppDispatch, useAppSelector } from '../../stores/store';
import { playerActions } from './playerSlice';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { playerUIActions } from './playerUISlice.ts';

interface IProps {
    isOpen: boolean,
    value: number,
    isMuted: boolean,
    setIsOpen: (isOpen: boolean) => void,
}

export const PlayerVolume = forwardRef<{ closePopup: () => void }, IProps>(({ isOpen, value, setIsOpen }, ref) => {
        const dispatch = useAppDispatch();
        const popupRef = useRef<HTMLDivElement>(null);
        const isMuted = useAppSelector((state) => state.player.muted);
        const volume = useAppSelector((state) => state.player.volume);

        const handleAnimationEnd = () => {
            if (popupRef.current)
                popupRef.current.removeAttribute('close');
        };

        const closePopup = () => {
            if (isOpen && popupRef.current) {
                popupRef.current.setAttribute('close', '');
                setIsOpen(false);
            }
        };

        const togglePopup = () => {
            if (popupRef.current) {
                if (isOpen) {
                    popupRef.current.setAttribute('close', '');
                }
                setIsOpen(!isOpen);
            }
        };

        const handleButtonOnClick = () => {
            togglePopup();
        };

        useImperativeHandle(ref, () => ({
            closePopup,
        }));
        return (
            <div className={'relative flex items-center'}>
                <button onClick={handleButtonOnClick}>
                    {isMuted || volume === 0.0 ?
                        <SpeakerXMarkIcon className={'w-7 h-7'} /> :
                        <SpeakerWaveIcon className={'w-7 h-7'} />
                    }
                </button>
                <div
                    className={`popup`} ref={popupRef}
                    data-open={isOpen ? isOpen : undefined}
                    onAnimationEnd={handleAnimationEnd}
                    onMouseEnter={() => {
                        dispatch(playerUIActions.setIsMenuUIHovered(true));
                    }}
                    onMouseLeave={() => {
                        dispatch(playerUIActions.setIsMenuUIHovered(false));
                    }}
                >
                    <div
                        className={`absolute flex items-center space-x-2 -right-6 -bottom-14 w-40 h-10 bg-white z-50 rounded-sm px-4 py-1 text-neutral-700`}>
                        <button onClick={() => dispatch(playerActions.toggleMuted())}>
                            {isMuted ?
                                <SpeakerXMarkIcon className={'w-6 h-6'} />
                                :
                                <SpeakerWaveIcon className={'w-6 h-6'} />}
                        </button>
                        <div className={'h-full w-0.5 bg-neutral-300 rounded-full'} />
                        <input
                            id="default-range"
                            type="range"
                            min={0.0}
                            max={1.0}
                            step={0.1}
                            value={value}
                            onChange={(e) => dispatch(playerActions.setVolume(Number(e.target.value)))}
                            className="accent-[#008DD2] hover:accent-[#007CC1] focus:outline-hidden transition-all w-full h-8 bg-blue-200 rounded-lg cursor-pointer dark:bg-blue-700"
                        />
                    </div>
                    <div
                        className="absolute right-2 -bottom-4 border-solid border-b-white border-b-8 border-x-transparent border-x-8 border-t-0" />
                </div>
            </div>
        );
    },
);